import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import { RelatedObjectOptions } from "../../services/navigation-data-service/NavigationDataService";

export const keys = {
    all: ["breadcrumb"],
    data: (
        customerID: number,
        viewID: UIViewEnum,
        routeContext: RouteContextType,
        offlineDataLoaded: boolean,
        offline: boolean,

    ) => [
            ...keys.all,
            "data", {
                customerID,
                viewID,
                routeContext,
                offlineDataLoaded,
                offline
            }
        ],


    availableObjects: (

        customerID: number, 
        contextGroupID: number,  
        contextObject: IeLynxObject, 
        viewID: UIViewEnum,
        options: RelatedObjectOptions,
        offline: boolean

    ) => [
        ...keys.all,
        "availableObjects",
        {
            customerID,
            contextGroupID,
            contextObject,
            viewID,
            options,
            offline
        }
    ]
};
